
import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import {SavedListingRepository} from "../saved-listings/SavedListingRepository.js";

let $=jQuery.noConflict();
export class ZIDXAccount implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountContainer";
    }
    render(){
        let self=this;
        // console.log("account");
        // let savedListings=localStorage.getItem("zidx.savedListings");
        // if(savedListings!=null && savedListings!="" && savedListings!="[]"){
        //     $("#userAccountList", this.zidx.peakidxShadowRoot).append("<p><a href='"+this.zidx.getPrefixURL("/saved-listings/")+"' class=\"zidxButton\">Saved Listings</a></p>");
        // }
        // let savedSearches=localStorage.getItem("zidx.savedSearches");
        // if(savedSearches!=null && savedSearches!="" && savedSearches!="[]"){
        //     $("#userAccountList", this.zidx.peakidxShadowRoot).append("<p><a href='"+this.zidx.getPrefixURL("/saved-searches/")+"' class=\"zidxButton\">Saved Searches</a></p>");
        // }

        if(this.zidx.isContactLoggedIn() && !this.zidx.isContactGuest()) {
            SavedListingRepository.getInstance(self.zidx).syncWithServer();

            $(".zidxContactRegisterButtonContainer", this.zidx.peakidxShadowRoot).hide();
            $("#userAccountList", this.zidx.peakidxShadowRoot).append("<p><a href='" + this.zidx.getPrefixURL("/account/?zlogout=1") + "' class=\"zidxButton\">Logout</a></p>");
        }else{
            $(".zidxContactRegisterButton", this.zidx.peakidxShadowRoot).on("click", function(e){
                e.preventDefault();
                self.zidx.showLoginForm();
            });
        }
    }
}